import React, { useEffect, createContext, useState } from 'react';
import { useMemo } from 'react';

export const userAuth = createContext({});

const getStoredToken = () => {
	try {
		return JSON.parse(localStorage.getItem('user-auth')) || {};
	} catch (error) {
		localStorage.removeItem('user-auth');
		return {};
	}
};

const UserContextProvider = ({ children }) => {
	const [token, setToken] = useState(getStoredToken);
	//
	useEffect(() => {
		const gettoken = getStoredToken();
		if (gettoken) {
			setToken(gettoken);
		}
	}, []);

	const values = useMemo(
		() => ({
			token,
			setToken,
		}),
		[token],
	);
	return <userAuth.Provider value={values}>{children}</userAuth.Provider>;
};

export default UserContextProvider;
